import styled from 'styled-components'

import { barnesTheme } from '../../theme/barnesTheme'

export const ValuationCard = styled.div`
  width: 100%;
  padding: 24px;
  box-sizing: border-box;
  margin-top: ${barnesTheme.spacing.sectionGap};
  text-align: center;

  @media print {
    width: 100% !important;
    padding: 24px !important;
    box-sizing: border-box !important;
    margin-top: ${barnesTheme.spacing.sectionGap} !important;
    text-align: center !important;
  }
`

export const ValuationLabel = styled.div`
  font-family: ${barnesTheme.fonts.body};
  font-size: ${barnesTheme.fontSizes.medium};
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.textLight};

  @media print {
    font-size: ${barnesTheme.fontSizes.medium} !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ValuationPrice = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-size: ${barnesTheme.fontSizes.hero};
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.accent};
  margin-top: 8px;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-size: ${barnesTheme.fontSizes.hero} !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.accent} !important;
    margin-top: 8px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ValuationRange = styled.div`
  font-family: ${barnesTheme.fonts.body};
  font-size: ${barnesTheme.fontSizes.medium};
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.textLight};
  margin-top: 4px;

  @media print {
    font-size: ${barnesTheme.fontSizes.medium} !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.textLight} !important;
    margin-top: 4px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ValuationPerSqm = styled.div`
  font-family: ${barnesTheme.fonts.body};
  font-size: ${barnesTheme.fontSizes.body};
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.textLight};
  margin-top: 4px;

  @media print {
    font-size: ${barnesTheme.fontSizes.body} !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.textLight} !important;
    margin-top: 4px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const RangeBarContainer = styled.div`
  margin-top: ${barnesTheme.spacing.contentGap};
  width: 100%;
  height: 60px;
  position: relative;

  @media print {
    margin-top: ${barnesTheme.spacing.contentGap} !important;
    width: 100% !important;
    height: 60px !important;
    position: relative !important;
  }
`

export const Hairline = styled.div`
  width: 100%;
  height: 1px;
  background: ${barnesTheme.colors.border};
  margin: ${barnesTheme.spacing.contentGap} 0;

  @media print {
    width: 100% !important;
    height: 1px !important;
    background: ${barnesTheme.colors.border} !important;
    margin: ${barnesTheme.spacing.contentGap} 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const EvalSectionTitle = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-size: 13px;
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.accent};
  margin-bottom: ${barnesTheme.spacing.smallGap};

  @media print {
    font-size: 13px !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.accent} !important;
    margin-bottom: ${barnesTheme.spacing.smallGap} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const EvalList = styled.div`
  display: flex;
  flex-direction: column;

  @media print {
    display: flex !important;
    flex-direction: column !important;
  }
`

export const EvalRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid ${barnesTheme.colors.border};

  &:last-child {
    border-bottom: none;
  }

  @media print {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    padding: 8px 0 !important;
    border-bottom: 1px solid ${barnesTheme.colors.border} !important;

    &:last-child {
      border-bottom: none !important;
    }
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const EvalName = styled.div`
  font-family: ${barnesTheme.fonts.body};
  font-size: ${barnesTheme.fontSizes.body};
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.primary};

  @media print {
    font-size: ${barnesTheme.fontSizes.body} !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const EvalDescription = styled.div`
  font-family: ${barnesTheme.fonts.body};
  font-size: 8px;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.textLight};

  @media print {
    font-size: 8px !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const EvalPrice = styled.div`
  font-family: ${barnesTheme.fonts.body};
  font-size: ${barnesTheme.fontSizes.body};
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.primary};
  text-align: right;
  white-space: nowrap;

  @media print {
    font-size: ${barnesTheme.fontSizes.body} !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.primary} !important;
    text-align: right !important;
    white-space: nowrap !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const EvalConfidence = styled.div`
  font-family: ${barnesTheme.fonts.body};
  font-size: 8px;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.textLight};
  margin-left: 8px;
  white-space: nowrap;

  @media print {
    font-size: 8px !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.textLight} !important;
    margin-left: 8px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MethodologyText = styled.div`
  font-family: ${barnesTheme.fonts.body};
  font-size: 8px;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.textLight};
  line-height: 1.6;
  margin-top: ${barnesTheme.spacing.contentGap};

  @media print {
    font-size: 8px !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.textLight} !important;
    line-height: 1.6 !important;
    margin-top: ${barnesTheme.spacing.contentGap} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const DisclaimerSection = styled.div`
  margin-top: ${barnesTheme.spacing.smallGap};

  @media print {
    margin-top: ${barnesTheme.spacing.smallGap} !important;
  }
`

export const DisclaimerText = styled.div`
  font-family: ${barnesTheme.fonts.body};
  font-size: 8px;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.textLight};
  line-height: 1.6;
  margin-top: 4px;

  @media print {
    font-size: 8px !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.textLight} !important;
    line-height: 1.6 !important;
    margin-top: 4px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* Legacy exports kept for backward compatibility */
export const TwoColumnCards = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${barnesTheme.spacing.contentGap};
  margin-top: ${barnesTheme.spacing.contentGap};

  @media print {
    display: flex !important;
    flex-direction: column !important;
    gap: ${barnesTheme.spacing.contentGap} !important;
    margin-top: ${barnesTheme.spacing.contentGap} !important;
  }
`

export const EvalColumn = styled.div`
  display: flex;
  flex-direction: column;

  @media print {
    display: flex !important;
    flex-direction: column !important;
  }
`

export const EvalCard = styled.div`
  box-sizing: border-box;

  @media print {
    box-sizing: border-box !important;
  }
`

export const ConfidenceBarWrapper = styled.div`
  display: none;
`

export const ConfidenceBarFill = styled.div<{ $width: number }>`
  display: none;
`

export const MethodologyBox = styled.div`
  margin-top: ${barnesTheme.spacing.contentGap};

  @media print {
    margin-top: ${barnesTheme.spacing.contentGap} !important;
  }
`
